// 数字转百分比
export const toPercent = (point) => {
    var str = Number(point * 100).toFixed(2);
    str += "%";
    return str;
}